import './VerifyEmail.css';
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Logout from '@mui/icons-material/Logout';

import SendMail from '../../../libraries/Icons/sendMail.png';

import {
    Signout,
    VerifyEmail as VerifyEmailUser,
} from '../../../services/Auth.service';

import {
    ResendVertificationEmail,
} from '../../../services/Profile.service';
import { getEndpointURL } from '../../../services/config';

const io = require("socket.io-client");
const baseURL = getEndpointURL();

function VerifyEmail(props) {
    const { translate, UserInfor, SnackbarAlert, ConfirmDialog } = props;
    const { token } = useParams();
    const navigate = useNavigate();

    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [email, setEmail] = React.useState();
    const [loading, setLoading] = React.useState(false);

    const socketRef = React.useRef();

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const handleResendVerificationEmail = () => {
        let event;
        let locale = localStorage.getItem('local') || 'en';
        setLoading(true);
        event = ResendVertificationEmail(locale);
        event?.then(res => {
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`, { email: res?.data?.email }),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
        .catch(err => {{
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        }})
    }

    const handleClickSignout = () => {
        setAnchorElUser(null);
        props.dispatch({ 
          type: 'UPDATE_CONFIRMDIALOG', 
          ConfirmDialog: {
            open: true,
            title: translate('signout'),
            message: translate('signoutconfirm'),
            buttonName: translate('signout'),
            onClose: () => onCloseConfirmDialog(),
            onAgree: () => onAgreeConfirmDialog()
          } 
        });
    };

    const onCloseConfirmDialog = () => {
        props.dispatch({ type: 'UPDATE_CONFIRMDIALOG', ConfirmDialog: {...ConfirmDialog, open: false} });
    }
    
    const onAgreeConfirmDialog = () => {
        Signout();
        props.dispatch({ type: 'UPDATE_USER_INFOR', UserInfor: {} });
        props.dispatch({ type: 'UPDATE_CONFIRMDIALOG', ConfirmDialog: {...ConfirmDialog, open: false} });
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        socketRef.current = io(baseURL);
        socketRef.current.on("verify-email-success", (_token) => {
            if(token === _token) window.location.href = "/control-center/dashboard";
        });
        return () => {
            socketRef.current.disconnect();
        };
    }, [])

    useEffect(() => {
        if(token) {
            VerifyEmailUser(token)
            .then(res => {
                props.dispatch({ type: 'UPDATE_USER_INFOR', UserInfor: res?.data?.userInfor });
            })
            .catch(err => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                navigate(`/sign-in`)
            })
        }
    }, [])

    return (
        <div>
            <Container maxWidth="md" sx={{ my: 20 }}>
                <Box sx={{ my: 4 }}>
                    <img height="50px" src={SendMail} />
                </Box>
                <Typography variant="h4" gutterBottom component="div" sx={{ textAlign: "center", mb: 10 }}>
                    {translate('almostdone')}<br/>
                    {translate('pleaseverifyyouremailaddress')}
                </Typography>
                <Box>
                    <Typography variant="subtitle1" gutterBottom component="div" sx={{ textAlign: "center" }}>
                        {`${translate('wehavesentanemailto')} `}<strong>{UserInfor?.email}</strong>
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom component="div" sx={{ textAlign: "center" }}>
                        {translate('pleasecheckittoverifyyouremail')}
                    </Typography>
                    <Box sx={{ my: 5, display: "flex", justifyContent: "center", gap: 1 }}>
                        <LoadingButton
                            onClick={handleResendVerificationEmail}
                            endIcon={<SendIcon />}
                            loading={loading}
                            loadingPosition="end"
                            variant="outlined"
                            >
                            {translate('resendverificationemail')}
                        </LoadingButton>
                        <Button variant="outlined" color='secondary' startIcon={<Logout />} onClick={handleClickSignout}>
                        {translate('signout')}
                        </Button>
                    </Box>
                    <Typography variant="subtitle2" gutterBottom component="div" sx={{ textAlign: "center" }}>
                        {`${translate('needhelp')} ${translate('contactusat')} `} <Link underline="none" href={`mailto:${process.env.REACT_APP_INFOR_SALE_MAIL}`}>{process.env.REACT_APP_INFOR_SALE_MAIL}</Link>.
                    </Typography>
                </Box>
            </Container>
        </div>
    )
}
function mapStateToProps(state) {
    return {
        UserInfor: state.UserInfor,
        SnackbarAlert: state.SnackbarAlert,
        ConfirmDialog: state.ConfirmDialog,
    }
}
export default connect(mapStateToProps)(withTranslate(VerifyEmail));
